// Constants
const imgView = document.getElementById('img-view');
const imgViewImg = imgView.getElementsByTagName('img')[0];
// Calc copyright year
const elem = document.getElementById('copyright');
elem.innerText = 'Copyright ' + new Date().getFullYear();
for (const img of Array.from(document.getElementsByTagName('img')))img.title = img.alt;
// Decode base64-encoded email addresses into real mailto: links at load time.
// Keeps the plaintext address out of the served HTML (scraper protection) while
// producing a native anchor that works on mobile.
for (const link of Array.from(document.querySelectorAll("a.email"))){
    const encoded = link.dataset.email;
    if (encoded) link.href = "mailto:" + atob(encoded);
}
// Functions
function hideImgView() {
    imgView.classList.remove('show');
}
function showImgView(img) {
    imgViewImg.src = img.src;
    imgViewImg.alt = img.alt;
    imgViewImg.title = img.title;
    imgView.classList.add('show');
}
// Img View
imgView.addEventListener('click', ()=>{
    hideImgView();
});
document.querySelectorAll(".gallery img").forEach((img)=>{
    img.addEventListener('click', ()=>{
        showImgView(img);
    });
});

//# sourceMappingURL=pages.e131e20d.js.map
